<template>
  <div class="card">
    <div class="p-3 pt-0 text-center card-body">
      <h4 class="mb-0 text-center mt-3">{{ title }}</h4>
      <hr class="my-3 horizontal dark" />
      <font-awesome-icon :icon="classIcon" size="6x" />
      <hr class="my-3 horizontal dark" />
      <button v-if="showButton" class="button button-1" v-on:click="goTo(to)">View site</button>
    </div>
  </div>
</template>

<style scoped>
@import './DefaultInfoCard.css';
</style>

<script>
export default {
  name: 'default-info-card',
  props: {
    icon_bg: {
      type: String,
      default: 'bg-white',
    },
    classIcon: {
      type: String,
      required: true,
    },
    title: String,
    to: String,
    showButton: Boolean,
  },
  methods: {
    goTo: function (to) {
      window.open(to, '_blank');
    },
  },
}
</script>